const IST = 'Asia/Kolkata';

/** YYYY-MM-DD in Asia/Kolkata */
export const toDayKey = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString('en-CA', { timeZone: IST });
};

export const todayKey = () => toDayKey(new Date());

export const yesterdayKey = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return toDayKey(d);
};

export const orderDayKey = (order) => {
  const t = order?.createdAt?.toDate?.();
  return t ? toDayKey(t) : null;
};

export const orderOnDay = (order, dayKey) => orderDayKey(order) === dayKey;

/** Day the order was delivered (IST), for rider cash settlement */
export const deliveredOrderDayKey = (order) => {
  const t = order?.deliveredAt?.toDate?.()
    || order?.updatedAt?.toDate?.()
    || order?.createdAt?.toDate?.();
  return t ? toDayKey(t) : null;
};

export const deliveredOnDay = (order, dayKey) => deliveredOrderDayKey(order) === dayKey;

export const formatDayLabel = (dayKey) => {
  if (dayKey === todayKey()) return 'Today';
  if (dayKey === yesterdayKey()) return 'Yesterday';
  const [y, m, d] = dayKey.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', {
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
  });
};

export const buildHourlyChart = (items, dayKey, valueKey = 'total') => {
  const maxHour = dayKey === todayKey() ? new Date().getHours() : 23;
  return Array.from({ length: maxHour + 1 }, (_, hour) => {
    const label = `${hour.toString().padStart(2, '0')}:00`;
    const inHour = items.filter((item) => {
      const t = item.createdAt?.toDate?.();
      if (!t || toDayKey(t) !== dayKey) return false;
      return t.getHours() === hour;
    });
    const revenue = inHour.reduce((s, item) => s + (item[valueKey] || 0), 0);
    return { label, count: inHour.length, revenue };
  });
};
